module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/case-study-retail-37137726091cbef9525a1be3f1b3af6b.jpg";